// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"169":"792a2674","335":"f6c5b922","336":"b3a6afe5","394":"43b00c7c","496":"fe881fe0","503":"6b89dc85","692":"aa7d2c7d","725":"f2f2d579","760":"92b3e618","789":"01848259"}[chunkId] + ".js";
};